var collapsible_list_component_rtlignore_default = {
  "ltr": "f-3t6",
  "rtl": "BmeVc",
  "iconContainer": "_4RY3s",
  "icon": "_1mvT0",
  "isExpanded": "L-WZD",
  "listDimensions": "f3lfr"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
